<template>
  <v-dialog v-model="dialog" persistent scrollable width="800px" @keydown.esc="hide">
    <v-form>
      <v-card>
        <v-card-title class="card-panel blue lighten-3">Новые юниты для бренда {{ brand.brandName }}</v-card-title>

        <v-card-text class="mt-2" style="height: 500px;">
          <v-checkbox v-for="(product, idx) in products"
            v-model="form.products"
            :key="stamp+'_'+idx"
            :label="productName(product)"
            :value="product.productID"
            hide-details
            multiple
            :color="units.includes(product.productID) ? 'red' : ''"
            class="mt-1"></v-checkbox>
        </v-card-text>
        <v-divider/>

        <v-card-actions>
          <v-btn raised autofocus @click="hide">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" raised color="primary" :disabled="$v.$invalid" :loading="loading" @click.prevent="submitAction">Добавить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import api from '@/api'
import { validationMixin } from 'vuelidate'
import { required, numeric, between } from 'vuelidate/lib/validators'
import { combinedObject } from '@/common.js'

export default {
  mixins: [ validationMixin ],
  props: [ 'activity' ],
  data: () => ({
    stamp: 0,
    dialog: false,
    loading: false,
    brand: {},
    form: {},
    products: [],
    units: []
  }),
  validations: {
    form: {
      products: { required },
    }
  },
  methods: {
    productName (product) {
      return (product.product_is_pack ? 'Пакет: ' : '') +
        (product.productName == '' ? product.spot.spotName : product.productName) + ' / '+product.productPrice*1+' ₴' +
        (product.product_is_multi ? ' / групповой' : '')
    },
    new (brand, units) {
      this.loading = true
      api.get('products/list').then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) this.$root.$alert(response.data.data, true)

        this.brand = brand
        this.units = units ? units.reduce((acc, cur) => (acc.push(cur.productID), acc), []) : []

        this.stamp = Date.now()
        this.products = combinedObject(response.data.data.cols, response.data.data.rows)
        let spots_obj = response.data.data.spots.reduce((acc, cur, idx) => (acc[cur.spotID] = cur, acc), {})
        this.products.forEach((cur, idx, arr) => (cur.spot = spots_obj[cur.spotID], cur.productPrice = cur.productPrice))
        this.dialog = true
      })
    },
    hide () {
      this.dialog = false
    },
    submitAction() {
      if ( this.$v.$invalid ) return
      let request = { brandID: this.brand.brandID, products: this.form.products }
      this.loading = true
      api.post('activities/addProducts/'+this.activity.activityID, request).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return alert(response.data.data)
        this.dialog = false
        this.form = {}
        this.$emit('updated');
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  },
}
</script>
